import { Keuzehulp } from '../keuzehulpen'

const verkenUwWensenVoorZorgEnBehandeling: Keuzehulp = {
  title: 'Verken uw wensen voor zorg en behandeling',
  basePath: '/verken-uw-wensen-voor-zorg-en-behandeling',
  documentTitle: 'Verken uw wensen voor zorg en behandeling',
  routes: [
    {
      path: '',
      routeId: 'P1-001',
      nextRouteId: 'P1-002',
      type: 'intro',
      title: 'Voordat u begint…',
      backButton:
        'https://www.thuisarts.nl/keuzehulp/verken-uw-wensen-voor-zorg-en-behandeling',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die u nodig heeft om de keuzehulp in te vullen',
        },
        {
          title: '30 tot 45 minuten',
          description: 'Zo lang doen de meeste mensen over deze keuzehulp',
        },
        {
          title: 'Zoek een rustig plekje',
          description: 'Zodat u zich zonder afleiding kunt concentreren',
        },
        {
          title: 'Bekijk en print uw antwoorden',
          description: 'Aan het einde kunt u uw antwoorden bekijken en printen',
        },
      ],
    },
    {
      path: '/stap-1',
      routeId: 'P1-002',
      nextRouteId: 'P1-003',
      type: 'chapter',
      title: 'Nadenken over uw wensen',
      subtitle: 'Stap 1',
      description:
        'In deze stap denkt u na over wat voor u belangrijk is als het gaat om zorg en behandeling, en wat uw wensen zijn voor nu en later.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/acp-stap-1.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-1/wat-is-voor-u-belangrijk',
      routeId: 'P1-003',
      nextRouteId: 'P1-004',
      type: 'explanation',
      title: 'Wat is voor u belangrijk?',
      align: 'left',
      titleAlign: 'center',
      description:
        'Weten wat u belangrijk vindt in uw leven kan u helpen bij het nadenken over uw wensen voor toekomstige zorg en behandeling. Bijvoorbeeld dat u het belangrijk vindt om zonder pijn te leven. Of dat u graag zoveel mogelijk thuis behandeld wilt worden. Of dat het voor u belangrijk is om uw familie en vrienden dichtbij te hebben, of dat u kan genieten van de natuur.',
      videos: [
        {
          src: 'https://media.thuisarts.nl/nadenken-over-zorg-en-hulp-voor-later.mp4',
          soundSrc: 'https://media.thuisarts.nl/nadenken-over-zorg-en-hulp-voor-later.mp3',
          poster: 'https://media.thuisarts.nl/nadenken-over-zorg-en-hulp-voor-later.jpg',
          videoSize: '103.76mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/nadenken-over-zorg-en-hulp-voor-later.vtt',
              subtitleSize: '5kb',
            },
          ],
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-1/vraag-1',
      routeId: 'P1-004',
      nextRouteId: 'P1-005',
      type: 'question',
      title: 'Wat is voor u belangrijk?',
      subtitle: 'Vraag',
      descriptionAlign: 'left',
      description:
        '<p>Voorbeelden: zo lang mogelijk leven, zo prettig mogelijk leven, persoonlijke of religieuze overtuigingen, contact met uw naasten, lezen, zelfstandig blijven, zelf kunnen lopen.</p>',
      button: 'Volgende',
      questions: [
        {
          placeholder: 'Dit vind ik belangrijk…',
          title: 'Dit vind ik belangrijk',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-1/vraag-2',
      routeId: 'P1-005',
      nextRouteId: 'P1-006',
      type: 'question',
      title: 'Wat betekent dit voor uw zorg en behandelwensen?',
      subtitle: 'Vraag',
      button: 'Volgende',
      questions: [
        {
          placeholder:
            'Bijvoorbeeld: dat ik graag thuis behandeld wil worden, dat ik zolang mogelijk gezond en zelfstandig wil leven, dat ik wil stoppen met de behandeling als ik te veel moet lijden…',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-1/vraag-3',
      routeId: 'P1-006',
      nextRouteId: 'P1-007',
      type: 'question',
      title: 'Welke zorg wilt u wel of niet?',
      subtitle: 'Vraag',
      descriptionAlign: 'left',
      description:
        '<p>Bij voorkeur sluiten uw zorg en behandeling goed aan bij wat voor u belangrijk is. Het kan daarom helpen om te weten welke zorg en behandeling u wel of niet zou willen. Denk aan: ziekenhuiszorg, thuiszorg of mantelzorg. Maar ook aan: antibioticakuren, reanimatie, beademing en orgaantransplantaties.</p>',
      button: 'Volgende',
      questions: [
        {
          placeholder: 'Bijvoorbeeld ziekenhuiszorg',
          title: 'Dit wil ik liever <span>wel</span>',
          type: 'textarea',
        },
        {
          placeholder: 'Bijvoorbeeld reanimatie',
          title: 'Dit wil ik liever <span>niet</span>',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-1/uw-wensen-bij-ernstige-ziekte',
      routeId: 'P1-007',
      nextRouteId: 'P1-008',
      type: 'explanation',
      title: 'Uw wensen bij ernstige ziekte en als u niet meer beter wordt',
      align: 'left',
      titleAlign: 'center',
      description:
        'Wat u belangrijk vindt als u ernstig ziek bent, kan per persoon verschillen. Het kan zijn dat uw gezondheid steeds verder verslechtert, en dat u niet meer beter wordt. U kunt nadenken over wat voor zorg en behandeling u dan zou willen. Nadenken over uw kwaliteit van leven kan daarbij helpen: wanneer vindt u dat u een goed leven heeft?',
      button: 'Volgende',
    },
    {
      path: '/stap-1/vraag-4',
      routeId: 'P1-008',
      nextRouteId: 'P1-009',
      type: 'question',
      title: 'Wat heeft u geleerd van eerdere ervaringen?',
      subtitle: 'Vraag',
      descriptionAlign: 'left',
      description:
        '<p>Het kan zijn dat uzelf of iemand in uw omgeving een ernstige ziekte heeft, of een ongeluk heeft gehad. Het kan ook zijn dat u iets in het nieuws heeft gezien. Zijn er dingen die u hiervan heeft geleerd? Of heeft u bepaalde vragen?</p>',
      button: 'Volgende',
      questions: [
        {
          placeholder:
            'Bijvoorbeeld over zorg die u wel of juist niet wilt, of angsten of zorgen die u heeft?',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-1/vraag-5',
      routeId: 'P1-009',
      nextRouteId: 'P1-010',
      subtitle: 'Stelling',
      title: 'Ik wil zo lang mogelijk leven, ook al is mijn kwaliteit van leven niet heel goed',
      type: 'statement',
    },
    {
      path: '/stap-1/vraag-6',
      routeId: 'P1-010',
      nextRouteId: 'P1-011',
      subtitle: 'Stelling',
      title:
        'Ik wil verschillende behandelingen proberen, maar hiermee stoppen als mijn kwaliteit van leven niet meer goed is',
      type: 'statement',
    },
    {
      path: '/stap-1/vraag-7',
      routeId: 'P1-011',
      nextRouteId: 'P1-012',
      subtitle: 'Stelling',
      title:
        'Ik wil zo comfortabel en pijnvrij mogelijk leven, ook als dit betekent dat mijn leven wat korter duurt',
      type: 'statement',
    },
    {
      path: '/stap-2',
      routeId: 'P1-012',
      nextRouteId: 'P1-013',
      type: 'chapter',
      title: 'Bespreken van zorgwensen',
      subtitle: 'Stap 2',
      description:
        'Het is belangrijk om uw wensen voor uw toekomstige zorg en behandeling te bespreken met uw naasten en arts. Wanneer u zelf niet meer kunt vertellen wat u wilt, kunnen uw arts en uw naasten belangrijke beslissingen voor u nemen.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/acp-stap-2.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/de-zorgvertegenwoordiger',
      routeId: 'P1-013',
      nextRouteId: 'P1-014',
      type: 'explanation',
      title: 'De zorgvertegenwoordiger',
      align: 'left',
      titleAlign: 'center',
      description:
        'Een zorgvertegenwoordiger kan uw wensen en voorkeuren namens u vertellen wanneer u dat zelf niet meer kunt, bijvoorbeeld uw partner, familielid of vriend. Kies iemand van 18 jaar of ouder, en vraag of hij of zij deze rol op zich wil en kan nemen. Kies iemand die uw wensen duidelijk kan maken, ook wanneer hij of zij het niet daarmee eens is, en ook in moeilijke situaties. Bespreek ook wie eventueel uw zorgvertegenwoordiger kan vervangen. Vertel uw naasten en arts wie uw zorgvertegenwoordiger is. Hieronder kunt u een film bekijken over het aanwijzen van een zorgvertegenwoordiger.',
      videos: [
        {
          src: 'https://media.thuisarts.nl/zorgvertegenwoordiger-kiezen.mp4',
          soundSrc: 'https://media.thuisarts.nl/zorgvertegenwoordiger-kiezen.mp3',
          poster: 'https://media.thuisarts.nl/zorgvertegenwoordiger-kiezen.jpg',
          videoSize: '137.16mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/zorgvertegenwoordiger-kiezen.vtt',
              subtitleSize: '7kb',
            },
          ],
        },
      ],
      info: [
        {
          title: 'De zorgvertegenwoordiger',
          content:
            '<div><p>Er zijn ook regels over zorgvertegenwoordigers, klik <a href="https://www.thuisarts.nl/levenseinde/ik-word-niet-meer-beter#wat-als-u-zelf-niet-meer-kunt-beslissen" target="_blank">hier</a> voor deze regels.</p></div>',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-2/vraag-1',
      routeId: 'P1-014',
      nextRouteId: 'P1-015',
      subtitle: 'Vraag',
      title: 'Heeft u al eens over een zorgvertegenwoordiger nagedacht?',
      type: 'defaultQuestion',
    },
    {
      path: '/stap-2/vraag-2',
      routeId: 'P1-015',
      nextRouteId: 'P1-016',
      type: 'question',
      title: 'Wie zou u willen aanwijzen als uw zorgvertegenwoordiger?',
      subtitle: 'Vraag',
      descriptionAlign: 'left',
      description:
        '<p>U kunt de gegevens van deze persoon invullen zodat u dit tijdens een gesprek met uw arts of naasten aan hen kan doorgeven. Als u nog geen zorgvertegenwoordiger wil of kan aanwijzen kunt u deze vraag overslaan door op volgende te klikken.</p>',
      button: 'Volgende',
      questions: [
        {
          placeholder: 'Bijvoorbeeld uw partner, familie, vriend(in) of andere bekende',
          type: 'textfield',
        },
      ],
    },
    {
      path: '/stap-2/de-rol-van-uw-zorgvertegenwoordiger',
      routeId: 'P1-016',
      nextRouteId: 'P1-017',
      type: 'explanation',
      title: 'De rol van uw zorgvertegenwoordiger',
      align: 'left',
      titleAlign: 'center',
      description:
        'Op het moment dat u zelf uw wensen niet kunt aangeven, kan uw zorgvertegenwoordiger met uw arts overleggen over welke zorg en behandeling u het liefst gewild zou hebben. U kunt uw zorgvertegenwoordiger vertellen wat uw wensen zijn in verschillende omstandigheden.',
      button: 'Volgende',
    },
    {
      path: '/stap-2/vraag-3',
      routeId: 'P1-017',
      nextRouteId: 'P1-018',
      type: 'question',
      title:
        'Zijn er nog andere dingen waarvan u zou willen dat uw zorgvertegenwoordiger die aangeeft?',
      subtitle: 'Vraag',
      button: 'Volgende',
      questions: [
        {
          placeholder:
            'Bijvoorbeeld dat u het belangrijk vindt om zo lang mogelijk te leven, of dat u graag comfortabel en pijnvrij wilt leven.',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-2/in-gesprek-met-uw-zorgvertegenwoordiger',
      routeId: 'P1-018',
      nextRouteId: 'P1-019',
      type: 'explanation',
      title: 'In gesprek met uw zorgvertegenwoordiger',
      align: 'left',
      titleAlign: 'center',
      description:
        'Het kan lastig zijn om het gesprek te beginnen met degene die u graag als uw zorgvertegenwoordiger wilt aanwijzen. U kunt het gesprek beginnen door aan te geven dat u wilt praten over uw zorg en behandeling wanneer uw gezondheid slechter wordt, en wat u dan zou willen. Vertel degene wat u wel of niet zou willen in verschillende omstandigheden. Ook als u geen zorgvertegenwoordiger wilt aanwijzen, kunt met uw naasten praten over dit onderwerp. Klik <a href="https://www.ikwilmetjepraten.nu/" class="external-link" target="_blank">hier</a> voor meer informatie.',
      button: 'Volgende',
    },
    {
      path: '/stap-2/vraag-4',
      routeId: 'P1-019',
      nextRouteId: 'P1-020',
      type: 'question',
      title: 'Wat heeft u nodig om met uw zorgvertegenwoordiger in gesprek te gaan?',
      subtitle: 'Vraag',
      button: 'Volgende',
      questions: [
        {
          placeholder: 'Bijvoorbeeld tijd hebben om te praten, eraan toe zijn…',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-2/in-gesprek-met-uw-arts',
      routeId: 'P1-020',
      nextRouteId: 'P1-021',
      type: 'explanation',
      title: 'In gesprek met uw arts',
      align: 'left',
      titleAlign: 'center',
      description:
        'Ook met uw arts kunt u bespreken wat u belangrijk vindt en wat uw wensen zijn. Wanneer u met uw arts gaat spreken, denk dan ook na over vragen die u mogelijk wilt stellen.',
      info: [
        {
          title: 'Uitleg en voorbeeldvragen',
          content:
            '<div><p>U zou het gesprek kunnen beginnen door aan te geven dat u wilt praten over uw zorg en behandeling wanneer uw gezondheid slechter wordt, en wat u dan zou willen. U kunt bespreken of uw arts rekening wil houden met uw wensen, wanneer u deze zelf niet aan kunt geven.</p><p>Daarnaast kunt u ook <a href="https://www.thuisarts.nl/bezoek-aan-huisarts/ik-ga-naar-huisarts-wat-kan-ik-van-tevoren-doen-en-verwachten" target="_blank">vragen stellen aan uw arts</a>.</p></div>',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-2/vraag-5',
      routeId: 'P1-021',
      nextRouteId: 'P1-022',
      type: 'question',
      title: 'Wat zou u met uw arts willen bespreken?',
      subtitle: 'Vraag',
      button: 'Volgende',
      questions: [
        {
          placeholder:
            'Bijvoorbeeld mogelijkheden en wensen voor behandeling, uw gevoelens of angsten',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-3',
      routeId: 'P1-022',
      nextRouteId: 'P1-023',
      type: 'chapter',
      title: 'Vastleggen van zorgwensen',
      subtitle: 'Stap 3',
      description:
        'Uw wensen voor toekomstige zorg en behandeling en uw keuze voor een zorgvertegenwoordiger kunt u op papier vastleggen in een wilsverklaring. U kunt de inhoud van de wilsverklaring altijd weer veranderen wanneer u dat wenst.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/acp-stap-3.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/een-wilsverklaring-maken',
      routeId: 'P1-023',
      nextRouteId: 'P1-024',
      type: 'explanation',
      title: 'Een wilsverklaring maken',
      align: 'left',
      titleAlign: 'center',
      description:
        'Uw wensen voor toekomstige zorg en behandeling kunt u op papier vastleggen in een wilsverklaring. In een wilsverklaring kunnen uw naasten, uw zorgvertegenwoordiger en de behandelend arts zien wat uw wensen zijn, ook als u deze zelf niet kunt aangeven. Een wilsverklaring kan niet garanderen dat u de zorg krijgt die u wilt. Een wilsverklaring kan wel uw zorgvertegenwoordiger en arts helpen om zorgbeslissingen te maken. Bekijk de film over het schrijven van een wilsverklaring.',
      videos: [
        {
          src: 'https://media.thuisarts.nl/een-wilsverklaring-maken.mp4',
          soundSrc: 'https://media.thuisarts.nl/een-wilsverklaring-maken.mp3',
          poster: 'https://media.thuisarts.nl/een-wilsverklaring-maken.jpg',
          videoSize: '134.91mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/een-wilsverklaring-maken.vtt',
              subtitleSize: '7kb',
            },
          ],
        },
      ],
      info: [
        {
          title: 'De inhoud van uw wilsverklaring',
          content:
            '<div><p>In uw wilsverklaring kunt u opschrijven:</p><ul><li>Wat u belangrijk vindt in uw leven</li><li>Wat voor u een goede kwaliteit van leven is</li><li>Welke behandelingen u wel of niet wilt ondergaan</li><li>Of u nog naar een ziekenhuis wilt voor een behandeling of niet</li><li>Wat uw wensen zijn voor zorg rondom uw levenseinde</li><li>Wie u als uw zorgvertegenwoordiger wilt aanwijzen</li><li>Welke beslissingen uw zorgvertegenwoordiger voor u mag nemen</li></ul><p>U kunt in deze keuzehulp geen wilsverklaring opstellen, maar u kunt dit zelf doen met het onderstaande voorbeeld. <a href="https://www.thuisarts.nl/levenseinde/ik-wil-wensen-voor-mijn-levenseinde-vastleggen#hoe-moet-een-wilsverklaring-eruit-zien-" target="_blank">Bekijk een voorbeeld van een wilsverklaring</a> of <a href="https://www.rijksoverheid.nl/onderwerpen/levenseinde-en-euthanasie/vraag-en-antwoord/wilsverklaring-opstellen" class="external-link" target="_blank">meer informatie over de wilsverklaring</a>.</p></div>',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-3/vraag-1',
      routeId: 'P1-024',
      nextRouteId: 'P1-025',
      subtitle: 'Vraag',
      title: 'Heeft u al een wilsverklaring opgesteld?',
      type: 'defaultQuestion',
    },
    {
      path: '/stap-3/vraag-2',
      routeId: 'P1-025',
      nextRouteId: 'P1-026',
      type: 'question',
      title: 'Welke onderwerpen zou u willen vastleggen in een wilsverklaring?',
      subtitle: 'Vraag',
      descriptionAlign: 'left',
      description:
        '<p>Bijvoorbeeld wat u in het leven belangrijk vindt, wie uw zorgvertegenwoordiger is en welke behandelingen u wel en niet wilt. Als u al een wilsverklaring heeft, kunt u deze vraag overslaan door op volgende te klikken.</p>',
      button: 'Volgende',
      questions: [
        {
          placeholder: 'Onderwerpen die ik wil vastleggen in een wilsverklaring zijn…',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-3/wilsverklaring-bespreken-en-delen',
      routeId: 'P1-026',
      nextRouteId: 'P1-027',
      type: 'explanation',
      title: 'Wilsverklaring bespreken en delen',
      align: 'left',
      titleAlign: 'center',
      description:
        'Bespreek uw wilsverklaring met uw arts, uw zorgvertegenwoordiger en uw naasten wanneer u daar klaar voor bent. Uw arts kan dan doorvragen wat u precies bedoelt en de wilsverklaring opnemen in uw medisch dossier. Vergeet niet uw wilsverklaring op een logische plek in huis te leggen en een kopie te geven aan uw zorgvertegenwoordiger.',
      button: 'Volgende',
    },
    {
      path: '/stap-3/vraag-3',
      routeId: 'P1-027',
      nextRouteId: 'P1-028',
      subtitle: 'Vraag',
      title: 'Wanneer controleert u uw wilsverklaring?',
      type: 'uniqueQuestion',
      answers: [
        { title: 'Ieder jaar' },
        { title: 'Iedere 5 jaar' },
        { title: 'Alleen wanneer mijn gezondheid slechter wordt' },
      ],
    },
    {
      path: '/print-overview',
      routeId: 'P1-028',
      nextRouteId: 'end',
      type: 'end',
      header: {
        description:
          '<p>Deze antwoorden kunnen u helpen tijdens gesprekken met uw naasten en arts, en bij het opstellen van een wilsverklaring. Als uw wensen veranderen of als u uw document wilt aanpassen, kunt u de keuzehulp opnieuw invullen: de antwoorden worden niet opgeslagen.</p>',
      },
    },
  ],
}

export default verkenUwWensenVoorZorgEnBehandeling
